import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "mobile-nav",
  "aria-label": "모바일 빠른 메뉴"
}
const _hoisted_2 = { class: "mobile-nav__label" }

import { computed } from 'vue'
import { useRoute } from 'vue-router'
import AppIcon from '@/components/common/AppIcon.vue'
import { useMemberAuth } from '@/composables/useMemberAuth'


export default /*@__PURE__*/_defineComponent({
  __name: 'MobileBottomNav',
  setup(__props) {

const route = useRoute()
const { isLoggedIn } = useMemberAuth()

const items = computed(() => [
  { label: '홈', icon: 'mdi-home-outline', to: '/' },
  { label: '함우리몰', icon: 'mdi-storefront-outline', to: '/mall' },
  {
    label: isLoggedIn.value ? 'MY' : '로그인',
    icon: 'mdi-account-circle-outline',
    to: isLoggedIn.value ? '/my-info' : '/login',
  },
])

const SECTION_PATHS: Record<string, string[]> = {
  '/': ['/'],
  '/mall': ['/mall'],
}

function isActive(to: string): boolean {
  const group = SECTION_PATHS[to]
  if (group) {
    return group.some((path) => route.path === path || route.path.startsWith(`${path}/`))
  }
  return route.path === to || route.path.startsWith(`${to}/`)
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value, (item) => {
      return (_openBlock(), _createBlock(_component_router_link, {
        key: item.label,
        to: item.to,
        class: _normalizeClass(["mobile-nav__item", { 'is-active': isActive(item.to) }])
      }, {
        default: _withCtx(() => [
          _createVNode(AppIcon, {
            class: "mobile-nav__icon",
            icon: item.icon,
            size: 22
          }, null, 8, ["icon"]),
          _createElementVNode("span", _hoisted_2, _toDisplayString(item.label), 1)
        ]),
        _: 2
      }, 1032, ["to", "class"]))
    }), 128))
  ]))
}
}

})